import { cn } from "@/lib/utils"
import { Container } from "./Container"

interface SectionProps {
  children: React.ReactNode
  className?: string
  containerClassName?: string
}

export function Section({ children, className, containerClassName }: SectionProps) {
  // If className is provided, use it directly (override default)
  // Otherwise use default padding
  const sectionClassName = className || "py-16 md:py-20 lg:py-24"
  
  return (
    <section className={sectionClassName} suppressHydrationWarning>
      <Container className={containerClassName}>{children}</Container>
    </section>
  )
}

